import * as React from "react";
import { DialogProps } from "./Dialog.types";

const Dialog: React.FC<DialogProps> = ({
  isOpen,
  onClose,
  title,
  children,
  theme = "dark",
  showCloseButton = true,
  blurBackground = true,
  maxWidth = "500px",
}) => {
  if (!isOpen) return null;

  const backdropStyle: React.CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    backdropFilter: blurBackground ? "blur(4px)" : "none",
  };

  const dialogStyle: React.CSSProperties = {
    backgroundColor: theme === "dark" ? "#1F1F23" : "#FFFFFF",
    color: theme === "dark" ? "#FFFFFF" : "#000000",
    padding: "24px",
    borderRadius: "8px",
    minWidth: "300px",
    maxWidth,
    width: "90%",
    position: "relative",
    boxShadow:
      theme === "dark"
        ? "0 8px 32px rgba(0, 0, 0, 0.4)"
        : "0 8px 32px rgba(0, 0, 0, 0.15)",
    border: theme === "dark" ? "1px solid #404040" : "1px solid #E5E7EB",
  };

  const titleStyle: React.CSSProperties = {
    marginTop: 0,
    marginBottom: "20px",
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Inter, sans-serif",
    color: theme === "dark" ? "#FFFFFF" : "#111827",
  };

  const closeButtonStyle: React.CSSProperties = {
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    background: "transparent",
    fontSize: "24px",
    cursor: "pointer",
    color: theme === "dark" ? "#FFFFFF" : "#6B7280",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
  };

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={dialogStyle} onClick={(e) => e.stopPropagation()}>
        {title && <h3 style={titleStyle}>{title}</h3>}

        <div style={{ marginBottom: showCloseButton ? "16px" : "0" }}>
          {children}
        </div>

        {showCloseButton && (
          <button
            onClick={onClose}
            style={closeButtonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                theme === "dark" ? "#404040" : "#F3F4F6";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default Dialog;
